module.exports = __webpack_public_path__ + "img/mode_3.d3f4e0d2.png";